import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';
import { AuthService } from '@auth';
import { LocalizeService } from '@localization';

/**
 * Service to manage menu actions dynamically using a strategy-like approach.
 */
@Injectable({
  providedIn: 'root',
})
export class MenuActionService {
  private localizeService = inject(LocalizeService);
  private authService = inject(AuthService);
  private doc = inject(DOCUMENT)

  /**
   * A map that stores action types and their corresponding handler methods.
   */
  private actions: { [key: string]: (payload?: any) => void } = {
    SET_LANGUAGE: (payload) => this.setLanguage(payload),
    LOGOUT: () => this.logout(),
  };

  /**
   * Executes a registered action based on its type.
   * @param actionType The type of action to execute (e.g., 'SET_LANGUAGE', 'LOGOUT').
   * @param payload Optional payload required for some actions.
   */
  executeAction(actionType: string, payload?: any): void {
    const action = this.actions[actionType];
    if (action) {
      action(payload);
    } else {
      console.error(`Action type "${actionType}" is not supported.`);
    }
  }

  /**
   * Sets the active language for the application.
   * @param lang Language code to set as active (e.g., 'es', 'en').
   */
  private setLanguage(lang: string): void {
    this.localizeService.setActiveLang(lang);
  }

  /**
   * Logs out the user.
   * Placeholder for logout logic, e.g., clearing user session or tokens.
   */
  private logout(): void {
    this.authService.logout(this.doc)
  }
}
